import { apiInstance } from 'api/utils';
import { CaseType } from 'store/modules/Case/types';
import { CustomerType } from 'store/modules/Customers/types';

// TODO: remove test1 from url

// Casses
const casesApi = {
  createCase: (
    name: string,
    customers: Array<CustomerType>,
    adviser_id: number | null
  ) => {
    return apiInstance.request({
      method: 'POST',
      url: '/cases/',
      data: {
        name,
        customers,
        adviser_id
      }
    });
  },
  getLatestCases: (page_size = 10) => {
    return apiInstance.request({
      method: 'GET',
      url: '/cases/',
      params: {
        page_size
      }
    });
  },
  getCases: (params?: { page: any; search?: string; adviser_id?: number }) => {
    return apiInstance.request({
      method: 'GET',
      url: '/cases/',
      params: params
    });
  },
  downloadCases: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/cases/download-csv/',
      responseType: 'blob'
    });
  },
  resetCase: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/reset/`
    });
  },
  linkCustomerToCase: ({
    portfolio,
    customerId
  }: {
    portfolio: any;
    customerId: number;
  }) => {
    return apiInstance.request({
      method: 'PUT',
      url: `/cases/${portfolio}/customers/${customerId}/`
    });
  },
  getCaseInfo: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/`
    });
  },
  getLinkedCustomersToCase: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/customers/`
    });
  },
  editCase: ({ caseInfo }: { caseInfo: CaseType }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/cases/${caseInfo.id}/`,
      data: caseInfo
    });
  },
  deleteCase: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/cases/${portfolio}/`
    });
  },
  cloneCase: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/clone/`
    });
  },
  createFollowOnCase: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/follow_on/`
    });
  },
  getCaseCount: () => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/case-count`
    });
  },
  unsetRiskProfiler: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/cases/unset-risk-profiler/'
    });
  }
};

export default {
  ...casesApi
};
